import FormContainer from "@app/components/forms/container/FormContainer";
import {
  createModalComponent,
  ModalContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogClose,
  Button,
  DialogDescription,
  ModalProps,
} from "@shortsworks/ui";
import { clearAuthToken } from "@shortsworks/user-api";
import { useNavigate } from "react-router-dom";
import { Path } from "@app/route_path";
import { DEVICE, USER_DEVICE_TYPE } from "@app/types/device";
import { PlatformType } from "@app/types/platform";

const LogoutContent = (props: ModalProps) => {
  return (
    <ModalContent>
      <DialogHeader>
        <DialogTitle>로그아웃</DialogTitle>
        <DialogDescription>로그아웃 하시겟습니까?</DialogDescription>
      </DialogHeader>
      <DialogFooter>
        <Button className="p-0 w-24 h-10" onClick={() => props.close(false)}>
          취소
        </Button>
        <Button className="p-0 w-24 h-10" onClick={() => props.close(true)}>
          확인
        </Button>
      </DialogFooter>
    </ModalContent>
  );
};

export const LogoutModal = createModalComponent(LogoutContent);
